// extracted by mini-css-extract-plugin
module.exports = {"SubscribeInput":"SubscribeInput_SubscribeInput__DYpBJ","Input":"SubscribeInput_Input__QQosP","SubscribeButton":"SubscribeInput_SubscribeButton__sbxhk"};